
import React from 'react';

const ExamEmptyState = () => {
  return (
    <div className="rounded-md border p-8 text-center">
      <p className="text-muted-foreground">No exam results found with current filters</p>
      <div className="flex justify-center mt-4">
        <div className="w-20 h-20 flex items-center justify-center rounded-full bg-muted">
          <svg
            className="w-10 h-10 text-muted-foreground"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default ExamEmptyState;
